import { render, staticRenderFns } from "./ManualList.vue?vue&type=template&id=2cb7cd04&scoped=true"
import script from "./ManualList.vue?vue&type=script&lang=js"
export * from "./ManualList.vue?vue&type=script&lang=js"
import style0 from "./ManualList.vue?vue&type=style&index=0&id=2cb7cd04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7cd04",
  null
  
)

export default component.exports